document.addEventListener("DOMContentLoaded", async () => {
	const {initSwiperCarousel} = await import("@utils/swiperCarousel");
	const carousels = document.querySelectorAll('.b-related_cases-list_wrapper');

	carousels.forEach((carouselElement) => {
		const options = {
			navigation: {
				nextEl: carouselElement.parentElement.querySelector('.b-related_cases-nav.m-next'),
				prevEl: carouselElement.parentElement.querySelector('.b-related_cases-nav.m-prev'),
			},
			slidesPerView: 1,
			breakpoints: {
				768: {
					slidesPerView: 2, // 2 slides for screens 640px and up
					spaceBetween: 20,
				},
				1024: {
					slidesPerView: 3, // 3 slides for screens 1024px and up
					spaceBetween: 40,
				},
			}
		};

		initSwiperCarousel(options, carouselElement, false, true, true)
	});
});
